import { api } from '../../api';
import { studioApi } from '../studio/studio-api';
import { record } from '../studio/studio-content';
export function videoActionId(value: unknown, speech: 'original' | 'text') {
  const id = record(value)[speech === 'original' ? 'circle_app_id' : 'add_speech_app_id'];
  return Number.isSafeInteger(id) && Number(id) > 0 ? Number(id) : null;
}
/** Маршрут перехода публикует сервер. Прежний неподтверждённый pipeline не используется для новой речи. */
export async function videoResultTarget(speech: 'original' | 'text', signal: AbortSignal) {
  const screen = await api.request<Record<string, unknown>>('/app/studio/screens/video', { signal });
  const appId = videoActionId(record(screen.video).result_actions, speech);
  if (!appId) throw new Error('video_result_action_unavailable');
  const [app, form] = await Promise.all([studioApi.app(appId, signal), studioApi.form(appId, signal)]);
  const policy = record(form.constraints?.circle);
  const words = policy.video_speech_fields;
  if (
    signal.aborted ||
    app.id !== appId ||
    form.app_id !== appId ||
    !form.available ||
    !['who', 'circle'].includes(app.entry.screen) ||
    !['who', 'circle'].includes(form.screen) ||
    !form.fields.some(f => f.key === 'video' && f.upload?.kind === 'video')
  )
    throw new Error('video_result_action_unavailable');
  if (
    speech === 'text' &&
    (policy.own_video_new_words !== true ||
      !Array.isArray(words) ||
      !words.includes('text') ||
      !form.fields.some(f => f.key === 'text') ||
      !form.fields.some(f => f.key === 'voice_id'))
  )
    throw new Error('video_result_action_unavailable');
  if (speech === 'original' && policy.video_original_speech !== true) throw new Error('video_result_action_unavailable');
  const desired = speech === 'original' ? 'circle' : '9:16';
  const format = form.fields.find(f => f.key === 'format')?.values.includes(desired) ? desired : String(policy.default_format ?? '');
  return { appId, format };
}
